import { Component, h } from '@stencil/core';
import state from '@ugc-store';
import { modalZIndex } from '@ugc-utils/modal-z-index';

@Component({
  tag: 'ugc-share-modal',
  shadow: false,
})
export class UgcShareModal {
  handleClickShareModal() {
    state.isShowShareModal = false;
    state.shareUrl = '';
  }

  render() {
    const {
      isShowShareModal = false,
      shareUrl = '',
      qnaStaticLanguage: { IDS_UGC_REVIEWS_SHARE_TEXT: qnaShareText },
      reviewStaticLanguage: { IDS_UGC_REVIEWS_SHARE_TEXT: reviewShareText },
    } = state;

    return (
      <ugc-drawer
        isShow={isShowShareModal}
        modalTitle={qnaShareText || reviewShareText}
        isShowButton={false}
        handleCancel={this.handleClickShareModal.bind(this)}
        zIndex={modalZIndex['ugc-share-modal']}
      >
        {isShowShareModal && (
          <div class="mb-24">
            <share-widget-mobile url={shareUrl} />
          </div>
        )}
      </ugc-drawer>
    );
  }
}
